import { PAGE_TRACKING } from "~/tools/getTrackingCategoryName";

export const TRACKING_DATA = {
  onLoadModal: {
    category: PAGE_TRACKING.FLIGHTS_SUMMARY,
    action: "prime-popup",
    label: "prime-popup:onload_pag:summary",
  },
  onCloseModal: {
    category: PAGE_TRACKING.FLIGHTS_SUMMARY,
    action: "prime-popup",
    label: "prime-popup:close_pag:summary",
  },
};
